<template>
  <v-container>
    <v-row>
      <v-col cols="3">
        <v-row>
          <v-col cols="4">
            <v-btn id="taxCheckReconciliationFooterBtnStartOver" color="primary" rounded dense large
              @click="unReconcileItems">
              Start Over
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-btn id="taxCheckReconciliationFooterBtnReconcileAll"
             color="primary" rounded dense large @click="reconcileItems">
              Reconcile All
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="5">
        <v-row class="tax-checkreconciliationfooter-row" justify="center" align="baseline">
          <v-col cols="3" align="end">
            <span> <b>Check Amount </b></span>
          </v-col>
          <v-col cols="9">
            <v-text-field id="taxCheckReconciliationFooterTextCheckAmount"
             outlined v-model="checkAmount" @keydown.tab="onCheckAmountInput"
             @keydown.enter="onCheckAmountInput" />
          </v-col>
        </v-row>
        <v-row justify="center" align="start" dense>
          <v-col cols="3">
            <v-checkbox v-model="isTypeDecimal" @change="onChangeTypeDecimal"
              id="taxCheckReconciliationFooterCheckBoxTypeDecimal"
              label="Type Decimal" hide-details />
          </v-col>
          <v-col cols="2"></v-col>
           <v-col cols="7">
            <v-row>
              <v-col cols="12" class="d-flex align-center">
                <span class="mr-4">Number of Checks: </span>
                <v-text-field id="totalCountingOfCheck" dense class="flex-grow-1"
                  :value="totalCheckCount" readonly />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row justify="center" align="start" dense>
          <v-col cols="4">
            <v-autocomplete class="tax-check-recon-criteria-bank"
              id="taxCheckReconCriteriaBank" v-model="selectedBank"
              item-text="bankName" :items="banks" item-value="_id" label="Bank Account" />
          </v-col>

           <v-col cols="4">
            <v-btn
              label="Hide Selected"
              hide-details
              small
              color="primary"
              @click="onHideSelectedChange"
            >
              Hide Selected
            </v-btn>
          </v-col>
           <v-col cols="4">
            <v-btn
              label="Unhide Selected"
              hide-details
              small
              color="primary"
              @click="unHideSelected"
            >
              Unhide Selected
            </v-btn>
          </v-col>

        </v-row>
      </v-col>
      <v-col cols="4" justify="center" align="center">
        <v-row>
          <v-col cols="4">
            <span>Total Checks: </span>
          </v-col>
          <v-col cols="8">
            <v-text-field
              id="taxCheckReconciliationFootertextTotalCheck"
              class="mt-n4 ml-n4"
              v-model="checkTotalInput"
              :readonly="!isAllowEditCashTotalOnReconPage"
              @change="onCheckTotalChange"
              @blur="onCheckTotalChange" />
            <!-- <v-text-field id="taxCheckReconciliationFootertextTotalCheck" class="mt-n4 ml-n4"
              :value="`$ ${amountFormat(checkTotal)}`" readonly /> -->
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <span>Total Cash: </span>
          </v-col>
          <v-col cols="8">
            <v-text-field
              id="taxCheckReconciliationFootertextTotalCash"
              class="mt-n4 ml-n4"
              v-model="cashTotalInput"
              :readonly="!isAllowEditCashTotalOnReconPage"
              @change="onCashTotalChange"
              @blur="onCashTotalChange" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <span>Total Deposit: </span>
          </v-col>
          <v-col cols="8">
            <v-text-field id="taxCheckReconciliationFootertextTotaldeposit" class="mt-n4 ml-n4"
              :value="`$ ${amountFormat(depositTotal)}`" readonly />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-btn id="taxCheckReconciliationFooterBtnDepositList"
              color="primary" rounded dense small @click="PrintDepositList">
              Deposit List
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn id="taxCheckReconciliationFooterBtnDepositSlip"
              color="primary" rounded dense small @click="printSlipOutsideDialogBox">
              Deposit Slip
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {
  mapMutations, mapGetters, mapActions,
  mapState,
} from 'vuex';
import { clients } from '../../../../../util/clients';

import { generateQueryString } from '../../../../common/base/report/report-util';
import { checkStringEmptiness, amountFormat } from '../../../../../util/shared/vue-global';
import { getRawJwt } from '../../../../../util/jwt';
import { printerHandler } from '../../../../../util/pdf-to-printer.util';

const { backendRest } = clients.direct;

export default {
  name: 'CheckReconcilationFooter',
  data() {
    return {
      checkAmount: null,
      isTypeDecimal: true,
      selectedBank: null,
      banks: [],
      hideSelected: false,
      copyToKeepSelectedItems: [],
      editableCashTotal: 0,
      editableCheckTotal: 0,
      cashTotalInput: '',
      checkTotalInput: '',
    };
  },
  props: {
    reconcilledCrudKey: {
      type: String,
    },
    unreconcilledCrudKey: {
      type: String,
    },
    baseCrudKey: {
      type: String,
    },
    cashTotal: {
      type: Number,
      default: 0,
    },
    checkTotal: {
      type: Number,
      default: 0,
    },
    depositTotal: {
      type: Number,
      default: 0,
    },
    totalCheckCount: {
      type: Number,
      default: 0,
    },
    isAllowEditCashTotalOnReconPage: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.loadLists();
    this.editableCashTotal = this.cashTotal;
    this.cashTotalInput = this.cashTotal > 0 ? `$ ${this.cashTotal.toFixed(2)}` : '';
    this.checkTotalInput = this.checkTotal > 0 ? `$ ${this.checkTotal.toFixed(2)}` : '';
  },
  computed: {
    ...mapGetters(['todaysDate']),
    ...mapGetters('base/crud', [
      'criteria',
      'item',
      'items',
    ]),
    ...mapState({
      StoreSelItems: (state) => state.tax.taxCheckRecon.checkReconSelItems,

    }),
    reconcilationedItems() {
      const items = this.items(this.reconcilledCrudKey);
      const totalReconcilationedAmount = items.reduce((sum, item) => sum + item.amount, 0);
      return totalReconcilationedAmount;
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    queryString() {
      return this.queryStringCalcForDepositList({
        criteria: this.criteriaState,
        token: this.getAuthToken,
      });
    },

    getAuthToken() {
      return getRawJwt();
    },
  },
  watch: {
    cashTotal(newValue) {
      this.editableCashTotal = newValue;
      this.cashTotalInput = newValue > 0 ? `$ ${newValue.toFixed(2)}` : '';
    },
    checkTotal(newValue) {
      this.editableCheckTotal = newValue;
      this.checkTotalInput = newValue > 0 ? `$ ${newValue.toFixed(2)}` : '';
    },
  },
  methods: {
    amountFormat,
    ...mapActions(['reAuth', 'flashError']),
    ...mapMutations('base/crud', ['setIsVisible', 'setItem', 'setItems', 'setCriteria']),
    ...mapActions('tax/taxCheckRecon', [
      'upsertTaxCheckRecon',
      'loadTaxCheckRecon',
      'flagReconciledTaxCRPayments',
    ]),
    ...mapActions('shared/bank', [
      'loadBanks',
    ]),
    ...mapActions('SystemConfig', ['loadConfig']),
    queryStringCalcForDepositList({ criteria, token }) {
      const params = [];
      if (criteria.programType) {
        params.push(`programType=${criteria.programType}`);
      }
      if (criteria.payDate) {
        params.push(`payDate=${criteria.payDate}`);
      }
      if (criteria.wkStns) {
        params.push(`wkStns=${criteria.wkStns}`);
      }
      if (!checkStringEmptiness(this.selectedBank)) {
        params.push(`bank=${this.selectedBank}`);
      }
      if (token) {
        params.push(`token=${token}`);
      }
      if (this.hideSelected) {
        params.push(`hideSelected=${this.hideSelected}`);
      }
      if (criteria.hideShowChecks) {
        params.push(`hideShowChecks=${criteria.hideShowChecks}`);
      }
      return generateQueryString(params);
    },
    onCheckAmountInput(e) {
      e.preventDefault();
      this.$emit('checkAmountChange', this.checkAmount);
      e.target.select();
    },
    onChangeTypeDecimal() {
      this.$emit('isTypeDecimal', this.isTypeDecimal);
    },
    onCashTotalChange() {
      // Parse the value to remove currency formatting
      const numericValue = parseFloat(this.cashTotalInput.toString().replace(/[^\d.-]/g, '')) || 0;
      this.editableCashTotal = numericValue;
      // Update the display with formatted value
      this.cashTotalInput = numericValue > 0 ? `$ ${numericValue.toFixed(2)}` : '';
      // Emit the change to parent component
      this.$emit('cashTotalChange', numericValue);
    },
    onCheckTotalChange() {
      // Parse the value to remove currency formatting
      const numericValue = parseFloat(this.checkTotalInput.toString().replace(/[^\d.-]/g, '')) || 0;
      this.editableCheckTotal = numericValue;
      // Update the display with formatted value
      this.checkTotalInput = numericValue > 0 ? `$ ${numericValue.toFixed(2)}` : '';
      // Emit the change to parent component
      this.$emit('checkTotalChange', numericValue);
    },
    async handleItems(sourceCrudKey, targetCrudKey, isReconcileAll, isReconciledFlag) {
      const items = this.items(sourceCrudKey) || [];
      // sequence is per-workstation-per-day, continuing from whatever that
      // workstation already has reconciled, not restarting at 1 (Asana 1217964195948074)
      const nextOrderByWkstn = {};
      if (isReconcileAll) {
        (this.items(this.reconcilledCrudKey) || []).forEach((item) => {
          const workstation = Number(item.workstation);
          const seq = Number(item.order) % 1000;
          nextOrderByWkstn[workstation] = Math.max(nextOrderByWkstn[workstation] || 0, seq);
        });
      }
      // a record with no workstation on file can't be assigned a position, same
      // as the single-item path (CheckReconcilation.vue handleItem) - leave it
      // unreconciled rather than writing it with no order (Asana 1217964195948074)
      // within each workstation, assign the sequence in receipt/payment-number
      // order rather than whatever order the grid happened to list them in,
      // so ties in the source list don't scramble the Deposit List (Asana 1218154279269253)
      const itemsToReconcile = isReconcileAll
        ? items.filter((item) => Number(item.workstation) > 0).sort((a, b) => {
          const wkstDiff = Number(a.workstation) - Number(b.workstation);
          if (wkstDiff !== 0) return wkstDiff;
          const aNum = a.paymentNumber === undefined || a.paymentNumber === null ? '' : a.paymentNumber;
          const bNum = b.paymentNumber === undefined || b.paymentNumber === null ? '' : b.paymentNumber;
          if (aNum === bNum) return 0;
          return aNum > bNum ? 1 : -1;
        })
        : items;
      if (itemsToReconcile.length < items.length) {
        this.flashError(`${items.length - itemsToReconcile.length} record(s) have no workstation on file and cannot be reconciled. Contact support.`);
      }
      const filteredItems = itemsToReconcile.map((element) => {
        const el = { ...element };
        const workstation = Number(el.workstation);
        delete el.paymentDate;
        delete el.workstation;
        delete el.paymentNumber;
        delete el.checkNumber;
        delete el.paidBy;
        delete el.paymentType;
        delete el.cashTotal;
        delete el.amount;
        delete el.totalChange;
        delete el.hasFiles;
        delete el.highlightNoFiles;
        delete el.customkey;
        if (isReconcileAll) {
          nextOrderByWkstn[workstation] = (nextOrderByWkstn[workstation] || 0) + 1;
          el.order = nextOrderByWkstn[workstation];
          el.wkStns = workstation;
        } else {
          el.order = 0;
        }
        return el;
      });
      await this.upsertTaxCheckRecon({
        upserts: filteredItems,
        isReconcileAll,
        isReconciledFlag,
      });
      this.$emit('loadCRUDList');
    },
    async unReconcileItems() {
      await this.handleItems(this.reconcilledCrudKey, this.unreconcilledCrudKey, false, false);
    },
    async reconcileItems() {
      await this.handleItems(this.unreconcilledCrudKey, this.reconcilledCrudKey, true, false);
    },
    async printSlipOutsideDialogBox() {
      const { payDate } = this.criteriaState;
      const { jwt } = await this.reAuth();
      const params = [
        `payDate=${payDate}`,
        `checkTotal=${this.checkTotal}`,
        `cashTotal=${this.editableCashTotal}`,
        `depositTotal=${this.depositTotal}`,
        `totalCheckCount=${this.totalCheckCount}`,
        `bankId=${this.selectedBank}`,
        `token=${jwt}`,
      ];
      if (this.devSetting && this.devSetting.isTestEnvironment) {
        params.push('isTestCafe=1');
      }
      if (!this.selectedBank) {
        alert('Please select a bank');
      } else {
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/taxpayment/deposit-slip${queryString}`;
        printerHandler(this, { url, reportName: 'depositSlips', deafultPrinterMode: true });
      }
    },
    async PrintDepositList() {
      const params = [
        `checkTotal=${this.checkTotal}`,
        `cashTotal=${this.editableCashTotal}`,
        `depositTotal=${this.depositTotal}`,
      ];
      // Combine params with existing queryString
      const combinedQueryString = this.queryString ? `${this.queryString}&${params.join('&')}` : generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/checkRecon/depositList${combinedQueryString}`;
      // Through the print toolkit like the Deposit Slip beside it (Washington). A PC
      // whose toolkit has not answered yet still gets the plain PDF tab.
      printerHandler(this, { url, reportName: 'depositLists', deafultPrinterMode: true });
    },
    async loadBankList() {
      const bankList = await this.loadBanks({
        criteria: { isDepositSlipEnabled: true },
        baseCrudKey: 'sharedBank',
      });
      this.banks = bankList;
      return bankList;
    },
    async loadDefaultCashDepositBank() {
      const configData = await this.loadConfig({ requiredScope: 'glConfig' });
      const [item] = configData || [];
      return (item && item.configuration && item.configuration.cashDepositBank) || null;
    },
    setDefaultBank(bankList, cashDepositBank) {
      if (cashDepositBank && bankList.some((bank) => bank._id === cashDepositBank)) {
        this.selectedBank = cashDepositBank;
      } else if (bankList.length === 1) {
        this.selectedBank = bankList[0]._id;
      }
    },
    async loadLists() {
      const [bankList, cashDepositBank] = await Promise.all([
        this.loadBankList(),
        this.loadDefaultCashDepositBank(),
      ]);
      this.setDefaultBank(bankList, cashDepositBank);
    },
    async onHideSelectedChange() {
      const items = this.StoreSelItems || [];
      // if (this.hideSelected) {
      //   this.copyToKeepSelectedItems = [...items];
      // }
      // if (this.hideSelected === false) {
      //   items = this.copyToKeepSelectedItems;
      // }

      const filteredItems = items.map((element) => {
        const el = { ...element };
        delete el.paymentDate;
        delete el.workstation;
        delete el.paymentNumber;
        delete el.checkNumber;
        delete el.paidBy;
        delete el.paymentType;
        delete el.cashTotal;
        delete el.amount;
        delete el.totalChange;
        delete el.hasFiles;
        delete el.highlightNoFiles;
        delete el.customkey;
        return el;
      });
      await this.flagReconciledTaxCRPayments({
        upserts: filteredItems,
        isReconciledFlag: true,
      });
      // const fromWhere = true;
      this.$emit('loadCRUDList');
    },
    async unHideSelected() {
      const items = this.StoreSelItems || [];
      // if (this.hideSelected) {
      //   this.copyToKeepSelectedItems = [...items];
      // }
      // if (this.hideSelected === false) {
      //   items = this.copyToKeepSelectedItems;
      // }

      const filteredItems = items.map((element) => {
        const el = { ...element };
        delete el.paymentDate;
        delete el.workstation;
        delete el.paymentNumber;
        delete el.checkNumber;
        delete el.paidBy;
        delete el.paymentType;
        delete el.cashTotal;
        delete el.amount;
        delete el.totalChange;
        delete el.hasFiles;
        delete el.highlightNoFiles;
        delete el.customkey;
        return el;
      });
      await this.flagReconciledTaxCRPayments({
        upserts: filteredItems,
        isReconciledFlag: false,
      });
      // const fromWhere = true;
      this.$emit('loadCRUDList');
    },
  },
};
</script>
<style scoped>
.tax-checkreconciliationfooter-row {
  height: 80px;
  margin: 0px;
}
</style>
